module.exports = __webpack_public_path__ + "img/Dantam Hair 52.24f18267.jpg";